import styled from 'styled-components';
import { SearchParamsItem } from '../SearchParamsItem';
import { CONTAINER_QUERY_BREAKPOINTS } from '../../types';

export const Wrapper = styled.ul<{ parentWidth?: number }>`
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  padding: 0;
  margin: 0 0 16px 0 !important;
  font-size: 16px;

  ${({ parentWidth }) => {
    if (!parentWidth || parentWidth >= CONTAINER_QUERY_BREAKPOINTS.minMd) {
      return `
        font-size: 16px;
      `;
    }

    return `
        font-size: 16px;
    `;
  }}

  & > li {
    position: relative;
    padding-left: 8px;
    padding-top: 8px;

    ${({ parentWidth }) => {
      if (!parentWidth) {
        return '';
      }
      if (parentWidth >= CONTAINER_QUERY_BREAKPOINTS.minMd) {
        return `padding-right: 8px;`;
      }
      if (parentWidth >= CONTAINER_QUERY_BREAKPOINTS.minXs) {
        return `padding-right: 20px;`;
      }
      return '';
    }}
  }

  & > li:first-child {
    padding-left: 0;
    padding-right: 8px;
    ${({ parentWidth }) => {
      if (!parentWidth) {
        return '';
      }
      if (parentWidth >= CONTAINER_QUERY_BREAKPOINTS.minMd) {
        return `padding-right: 8px;`;
      }
      if (parentWidth >= CONTAINER_QUERY_BREAKPOINTS.minXs) {
        return `padding-right: 10px;`;
      }
      return '';
    }}
  }

  & > li:first-child:after {
    content: '';
    position: absolute;
    right: 0;
    bottom: 2px;
    display: block;
    width: 1px;
    height: 27px;
    padding-left: 0;
    background-color: #c2c5cc;
  }

  & > li:last-child {
    padding-right: 0;
    padding-left: 0;
    padding-top: 0;
    width: 100%;
    ${({ parentWidth }) => {
      if (parentWidth && parentWidth >= CONTAINER_QUERY_BREAKPOINTS.minXs) {
        return `
          padding-left: 8px;
          width: auto;
        `;
      }

      return '';
    }}
  }

  ${({ parentWidth }) => {
    if (!parentWidth || parentWidth < CONTAINER_QUERY_BREAKPOINTS.minMd) {
      return '';
    }

    return `
      width: 100%;
      flex-wrap: wrap;
      padding-left: 8px;
      & > li:last-child:after {
        content: '';
        position: absolute;
        left: 0;
        bottom: 2px;
        display: block;
        width: 1px;
        height: 27px;
        padding-left: 0;
        background-color: #c2c5cc;
      }
    `;
  }}
`;

export const StyledSearchParamsItem = styled<any>(SearchParamsItem)`
  width: 100%;

  ${({ parentWidth }) => {
    if (!parentWidth || parentWidth >= CONTAINER_QUERY_BREAKPOINTS.minMd) {
      return `
    max-width: 200px;
    `;
    }
    return `
    max-width: 180px;
    `;
  }}
`;
